"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const config_1 = require("./config");
class HostCache {
    constructor(params) {
        this.http = params.http || config_1.Config.httpService;
        this.directorBaseUrl = params.directorUrl || config_1.Config.createServiceUrl({
            service: 'director',
            version: '2018-07-01',
            cloud: params.cloud || config_1.Config.cloud,
        });
    }
    getServiceHost(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.serviceHostCache && !params.noCacheFetch) {
                const hostRecords = yield this.getServiceHosts();
                if (hostRecords) {
                    this.serviceHostCache = new Map();
                    for (const hostRecord of hostRecords) {
                        this.serviceHostCache.set(hostRecord.name, hostRecord.host);
                    }
                }
            }
            return this.serviceHostCache ? this.serviceHostCache.get(params.service) : undefined;
        });
    }
    /**
     * Request from the director for the highest ranked hosts.  Error response from the director will result in a null which shouldn't be cached.  If there is a response from the director but no records are found, any[] is returned which should be cached.
     *
     * @param service name of service to request
     */
    getServiceHosts() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.http.request({
                    url: `${this.directorBaseUrl}/services?$filter=rank eq 1`,
                    method: 'GET',
                });
                return _.get(response, 'body._embedded.items') || [];
            }
            catch (exception) {
                return null;
            }
        });
    }
}
exports.HostCache = HostCache;
